"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Alert.default;
  }
});

var _Alert = _interopRequireDefault(require("./Alert"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/Alert/index.js
// module id = 119
// module chunks = 0